import BaseService from "./Base"
import {get} from "lodash"

class UserProfessionalEducationalDevelopmentService extends BaseService {
    getAll = async (params = {}) => {
        const response = await this.post("/v1/user-professional-educational-development/list", params)
        return get(response, "data", [])
    }

    delete = async (params = {}) => {
        const response = await this.post("/v1/user-professional-educational-development/delete", params)
        return get(response, "data", {})
    }

    create = async (params = {}) => {
        const response = await this.post("/v1/user-professional-educational-development/create", params)
        return get(response, "data.data", {})
    }

    update = async (id, data, params = {}) => {
        data.userProfessionalEducationalDevelopmentId = id
        const response = await this.post("/v1/user-professional-educational-development/edit", data, params)
        return get(response, "data", {})
    }
}
export default UserProfessionalEducationalDevelopmentService
